<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m5 9c0-3.87 3.13-7 7-7s7 3.13 7 7c0 5.25-7 13-7 13s-7-7.75-7-13zm9.5 0c0 1.3807-1.1193 2.5-2.5 2.5s-2.5-1.1193-2.5-2.5c0-1.38071 1.1193-2.5 2.5-2.5s2.5 1.11929 2.5 2.5z"
      fill-rule="evenodd"
    />
  </svg>
</template>
